var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "snt-loading",
    {
      attrs: {
        loading: _vm.$apollo.loading,
        "content-class": "pa-3",
        "min-height": "150px",
      },
    },
    [!_vm.setting.peakAccountConnected ? _c("PeakForm") : _c("PeakLogout")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }